import { useQuery } from '@tanstack/react-query';
import { getPlaceById } from '../../api/place.ts';

export default function usePlace(placeId: string) {
  return useQuery({
    queryKey: ['places', placeId],
    queryFn: async () => {
      return await getPlaceById(placeId);
    },
    enabled: !!placeId,
  });
}
